import "core-js/modules/es.array.reduce.js";
export var translate = function translate(key, replacers, translations) {
  var translation = translations[key] ? translations[key] : key;
  return translation !== key && Object.keys(replacers).length > 0 ? Object.keys(replacers).reduce(function (acc, key) {
    return replaceKey(acc, key, replacers[key]);
  }, translation) : translation;
};

var replaceKey = function replaceKey(string, find, replace) {
  return string.replace(new RegExp('{(?:\\s+)?(' + find + ')(?:\\s+)?}', 'g'), replace.toString());
};